// mparle-header.js — sticky scroll-state toggle met hysteresis
//
// Hysteresis voorkomt flicker rond de drempel: bij scroll-down activeren we
// op 60px, bij scroll-up deactiveren we pas op 10px. Anders triggert de
// padding-change in de header een layout-shift die de scroll-Y verlegt, wat
// de class opnieuw togglet — een visuele knipper-loop.
(function () {
  const wrap = document.querySelector('.mp-headerwrap');
  if (!wrap) return;

  const ENTER = 60;
  const EXIT = 10;
  let scrolled = false;

  function onScroll() {
    const y = window.scrollY || document.documentElement.scrollTop;
    if (!scrolled && y > ENTER) {
      scrolled = true;
      wrap.classList.add('is-scrolled');
    } else if (scrolled && y < EXIT) {
      scrolled = false;
      wrap.classList.remove('is-scrolled');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// ── Mobile menu drawer ────────────────────────────────────────────
(function () {
  const drawer = document.getElementById('mp-mobile-menu');
  if (!drawer) return;
  const trigger = document.querySelector('[data-mp-mobile-menu-open]');
  const panel = drawer.querySelector('.mp-mobile-menu__panel');

  function open() {
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.body.classList.add('mp-has-mobile-menu');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    const firstLink = panel?.querySelector('a, button');
    firstLink?.focus({ preventScroll: true });
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mp-has-mobile-menu');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    setTimeout(() => { drawer.hidden = true; }, 280);
    trigger?.focus({ preventScroll: true });
  }

  trigger?.addEventListener('click', (e) => {
    e.preventDefault();
    open();
  });

  drawer.querySelectorAll('[data-mp-mobile-menu-close]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      close();
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  // Sluit drawer wanneer een nav-link wordt aangeklikt (navigatie volgt vanzelf)
  drawer.querySelectorAll('.mp-mobile-menu__nav a').forEach((a) => {
    a.addEventListener('click', () => close());
  });
})();

// ── Mega-menu openen met een klik ──────────────────────────────────
// De parent-items zijn knoppen, geen links: een klik toont het panel zodat de
// bezoeker daar zijn keuze maakt. Op desktop opent hover het panel al; deze
// toggle is er voor touch en toetsenbord.
(function () {
  const items = document.querySelectorAll('.mp-header__nav-item--has-sub');
  if (!items.length) return;

  function closeAll(except) {
    items.forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      item.querySelector('[data-mp-nav-parent]')?.setAttribute('aria-expanded', 'false');
    });
  }

  items.forEach((item) => {
    const btn = item.querySelector('[data-mp-nav-parent]');
    btn?.addEventListener('click', () => {
      const open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      closeAll(item);
    });

    // Ga je met de muis naar het andere menu-item, dan opent dat op hover;
    // een panel dat nog openstaat van een klik moet dan dicht.
    item.addEventListener('mouseenter', () => closeAll(item));
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.mp-header__nav-item--has-sub')) closeAll(null);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll(null);
  });
})();
